import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import RecipientDataService from "../../services/recipient-data-service/RecipientDataService";
import { IRecipientReferenceDTO } from "../../services/recipient-data-service/Models";

export type UseRecipientReferenceDataParms = {
    groupID: number,
    organizationID: number,
} & BaseUseQueryParameters<IRecipientReferenceDTO | undefined>;

export function useRecipientReferenceData({
    groupID,
    organizationID,
    enabled,    
    onSuccess,
    onError
}: UseRecipientReferenceDataParms) {
    return useQuery<IRecipientReferenceDTO, RestError>(
        keys.referenceData(organizationID),
        ({ signal }) => {
            return RecipientDataService.getReferenceData(
                groupID, 
                organizationID,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: false
        }
    );
}